import { Sorting } from '@unistocks/components/table/table';
import { SortOrder } from '@unistocks/proxy/axios-client';

export function mapSortingToParam<T>(sorting: Sorting<T>): string {
  const dir = sorting.direction === SortOrder.Ascending ? 'asc' : 'desc';
  return `${sorting.prop} ${dir}`;
}
